// Router utility for programmatic navigation from Redux actions
// Uses a singleton pattern to access React Router's navigate function

import { buildPath } from '../components/Link.jsx';

let navigateFunction = null;

export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

export const navigate = (path, options = {}) => {
  if (navigateFunction) {
    navigateFunction(path, options);
  } else {
    console.warn(
      'Navigate function not initialized. Call setNavigate() first.'
    );
  }
};

// Helper to match old next-routes pushRoute behavior
// Uses the same route map from Link.jsx
export const pushRoute = (routeName, params = {}) => {
  const path = buildPath(routeName, params);
  navigate(path);
};

// Helper to match old next-routes replaceRoute behavior
export const replaceRoute = (routeName, params = {}) => {
  const path = buildPath(routeName, params);
  navigate(path, { replace: true });
};
